// Liste d'icônes à mettre en cache à l'initialisation de l'application
import { AvailableIcons } from '@shared/enums';

export const iconList: (keyof typeof AvailableIcons)[] = ['CALENDAR', 'CHEVRON_RIGHT'];
